export const API_PATH_ApiTrafficStudyLogsLoadGet = '/services/traffic-studies/apiTrafficStudyLogsLoadGet';
